function HeroVideo() {
  return (
    <section className="relative h-screen">
      <video 
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay 
        muted 
        loop 
        playsInline
        preload="auto"
      >
        <source src="https://toyoesports.com/assets/videos/toyo-video-home.mp4" type="video/mp4" />
      </video>
    </section>
  );
}

export default HeroVideo;
